export { extractFromPath, getObjFromQueryString, getUrlObject } from './url.es.js';
export { PATTERN_VALIDATION, isValidCitizenIdNumber, isValidEmailFormat, isValidNewTaxCode, isValidPassportNumber, isValidPhoneFormat, isValidStateBudgetUnitCode, isValidTaxCode } from './validators.es.js';
export { formatDate } from './date.es.js';
export { htmlDecode, htmlEncode } from './html.es.js';
export { isFloat, stringToInteger } from './number.es.js';
export { COOKIE_OVER_18_YEARS_OLD, getCookieOver18YearOld, setCookieOver18YearOld } from './storage.es.js';
export { cancelIdleCallback, requestIdleCallback, scheduleTaskInIdleTime } from './polyfill.es.js';
export { normalizeText, parseJsonStringSafely } from './string.es.js';
export { ConditionalWrapper, ConditionalWrapperUsingCallback } from './tsx.es.js';
export { isEmptyObject } from './object.es.js';
export { resolveTekoPathname } from './link.es.js';
export { Browser, getBrowser, getVersionBrowser, isChrome, isEdge, isFireFox, isNotSupportRegexHasLookbehind, isSafari } from './browser.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const normalizePhone = (rawphone) => {
  const phone = rawphone.trim();
  if (phone.length > 10) {
    if (phone.startsWith("84"))
      return phone.replace("84", "0");
    if (phone.startsWith("+84"))
      return phone.replace("+84", "0");
    return phone;
  }
  return phone;
};
const customizedMessage = (message, fields) => {
  let resultMessage = message;
  fields.forEach(({ name, value }) => {
    const regex = new RegExp(`{${name}}`, "g");
    resultMessage = resultMessage.replace(regex, value);
  });
  return resultMessage;
};
const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
const toObject = (arr, keyField) => {
  let newArr = {};
  if (Array.isArray(arr)) {
    for (let i = 0; i < arr.length; i++) {
      const curr = arr[i];
      newArr = __spreadProps(__spreadValues({}, newArr), {
        [curr[keyField]]: curr
      });
    }
  }
  return newArr;
};
const cleanObject = (object) => {
  if (!object) {
    return object;
  }
  const newObj = {};
  const currentKeys = Object.keys(object);
  currentKeys.forEach((key) => {
    if (object[key] || object[key] === false || object[key] === 0) {
      newObj[key] = object[key];
    }
  });
  return newObj;
};
const formatCurrency = (money, isFull = true, thousandSeparator = ".") => {
  return `${money || money == 0 ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`) : money}${isFull ? "\u0111" : ""}`;
};
function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
const toFixed = ({
  value,
  precision,
  shouldRoundValue = true
}) => {
  return (!!shouldRoundValue ? Math.round(value * Math.pow(10, precision)) : Math.floor(value * Math.pow(10, precision))) / Math.pow(10, precision);
};
const chunkRender = async (data, render, chunkSize = 5) => {
  if (!data.length)
    return Promise.resolve([]);
  const safeChunkSize = Math.max(1, chunkSize);
  const result = [];
  const yieldToMainThread = () => new Promise((resolve) => {
    if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(() => resolve());
      return;
    }
    setTimeout(() => resolve(), 0);
  });
  for (let i = 0; i < data.length; i += safeChunkSize) {
    const chunk = data.slice(i, i + safeChunkSize);
    result.push(...chunk.map((item, index) => render(item, i + index)));
    if (i + safeChunkSize < data.length) {
      await yieldToMainThread();
    }
  }
  return result;
};

export { chunkRender, cleanObject, customizedMessage, debounce, formatCurrency, inIframe, normalizePhone, toFixed, toObject };
